import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import "./newform.css";
import FlexComponent from "../../FlexComponent";
import { useParams } from "react-router-dom";
import { useNewUser } from "../../../APIContext/NewUserContext";

const jerseySizes = [
  { label: "Small", value: "S" },
  { label: "Medium", value: "M" },
  { label: "Large", value: "L" },
  { label: "Extra Large", value: "XL" },
  { label: "Youth Small", value: "YS" },
  { label: "Youth Medium", value: "YM" },
  { label: "Youth Large", value: "YL" },
];

const gradeList = [
  { label: "2nd", value: "2nd" },
  { label: "3rd", value: "3rd" },
  { label: "4th", value: "4th" },
  { label: "5th", value: "5th" },
  { label: "6th", value: "6th" },
  { label: "7th", value: "7th" },
  { label: "8th", value: "8th" },
  { label: "High School", value: "High School" },
  { label: "College", value: "College" },
  { label: "Professional", value: "Professional" },
];

const genderList = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" },
];

const FormCom = () => {
  const {
    packageCategories,
    fetchInstructionCategories,
    addToCart,
    fetchGroupInstructions,
    packages,
    loading,
  } = useNewUser();
  // const { fetchPlayers, players } = usePlayerAccount()
  const { packageId } = useParams();
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    package_ids: [],
    player: {
      first_name: "",
      last_name: "",
      date_of_birth: "",
      jersey_size: "",
      grade: "",
      gender: "",
      school_name: "",
    },
  });

  useEffect(() => {
    if (packageId) {
      fetchGroupInstructions();
      fetchInstructionCategories(packageId);
    }
  }, [packageId]);

  const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const handleDateChange = (e) => {
    const dob = e.value;
    if (!dob) return;

    const year = dob.getFullYear();
    const month = String(dob.getMonth() + 1).padStart(2, "0");
    const day = String(dob.getDate()).padStart(2, "0");

    const formattedDOB = `${year}-${month}-${day}`;

    setFormData((prev) => ({
      ...prev,
      player: {
        ...prev.player,
        date_of_birth: formattedDOB,
      },
    }));
  };

  const handlePlayerChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      player: {
        ...prev.player,
        [name]: value,
      },
    }));
  };

  const handlePackageChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      package_ids: [Number(e.target.value)],
    }));
  };

  const packageName = packages?.find((item) => item.id == packageId)?.name;
  const selectedSession = packageCategories?.find(
    (session) => session.id === Number(formData.package_ids[0]),
  );
  const totalPrice = selectedSession ? selectedSession.price : "0.00";

  return (
    <>
      <div className="form-wrapper new-user">
        <div className="form-card">
          <div className="form-title text-clip">
            {capitalize(packageName)} Sessions
          </div>

          <div className="form-group">
            <FlexComponent>
              <label className="label-bold text-clip">
                {capitalize(packageName)} Sessions *
              </label>
            </FlexComponent>
            <select
              className="form-select"
              name="sessionType"
              value={formData.package_ids[0]} // use value instead of defaultValue for controlled component
              onChange={handlePackageChange}
              style={{ marginTop: "1rem" }}
            >
              <option value="">Select a session package</option>
              {packageCategories?.map((session) => (
                <option key={session.id} value={session.id}>
                  {session.name} - ${session.price}
                </option>
              ))}
            </select>
          </div>

          {/* Add Your Player Details */}
          <div className="child-details-container">
            <div style={{ marginTop: "1rem" }}>
              <label className="label-bold headings text-clip">
                Add Your Player Details
              </label>
            </div>

            <div className="child-details-container-2">
              <div className="form-item-new">
                <label className="label-bold text-clip">First Name</label>
                <input
                  type="text"
                  name="first_name"
                  className="form-input"
                  value={formData.player.first_name}
                  onChange={handlePlayerChange}
                />
              </div>

              <div className="form-item-new">
                <label className="label-bold text-clip">Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  className="form-input"
                  value={formData.player.last_name}
                  onChange={handlePlayerChange}
                />
              </div>

              <div className="form-item-new">
                <label className="label-bold text-clip">Date of Birth</label>
                <Calendar
                  placeholder="mm-dd-yyyy"
                  value={
                    formData.player.date_of_birth
                      ? new Date(formData.player.date_of_birth)
                      : null
                  }
                  onChange={handleDateChange}
                  showIcon
                  dateFormat="mm-dd-yy"
                  className="calesndr-cstm"
                />
              </div>

              <div className="form-item-new">
                <label className="label-bold text-clip">Gender</label>
                <select
                  className="form-select"
                  name="gender"
                  value={formData.player.gender}
                  onChange={handlePlayerChange}
                >
                  <option value="">Select</option>
                  {genderList?.map((i) => (
                    <option key={i.value} value={i.value}>
                      {i.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-item-new">
                <label className="label-bold text-clip">Grade</label>
                <select
                  className="form-select"
                  name="grade"
                  value={formData.player.grade}
                  onChange={handlePlayerChange}
                >
                  <option value="">Select</option>
                  {gradeList?.map((i) => (
                    <option key={i.value} value={i.value}>
                      {i.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-item-new">
                <label className="label-bold text-clip">Jersey</label>
                <select
                  className="form-select"
                  name="jersey_size"
                  value={formData.player.jersey_size}
                  onChange={handlePlayerChange}
                >
                  <option value="">Select</option>
                  {jerseySizes?.map((i) => (
                    <option key={i.value} value={i.value}>
                      {i.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-item-new">
                <label className="label-bold text-clip">School Name</label>
                <input
                  type="text"
                  name="school_name"
                  className="form-input"
                  value={formData.player.school_name}
                  onChange={handlePlayerChange}
                />
              </div>
            </div>
          </div>

          <div className="form-footer">
            <div className="total-row">
              <span className="total-label text-clip">TOTAL</span>
              <span className="total-amount text-clip">${totalPrice}</span>
            </div>
            <button
              onClick={() => {
                if (!formData.package_ids || !formData.player.first_name) return;

                addToCart(formData); // now sends exactly what you need
                setFormData({
                  package_ids: [],
                  player: {
                    first_name: "",
                    last_name: "",
                    date_of_birth: "",
                    jersey_size: "",
                    grade: "",
                    school_name: "",
                  },
                });
              }}
              className="add-cart-btn"
              disabled={
                !formData.package_ids ||
                !formData.player.first_name ||
                !formData.player.last_name
              }
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormCom;
